module.exports = __webpack_public_path__ + "static/3-Tri-06-781875210672ed06aeff64043d3ca716.png";